// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/sites-detail.less
// module id = 4121
// module chunks = 0